import { Injectable, Injector } from '@angular/core';
import { DocDynamicPageService } from '../pages/project-page/doc-dynamic-page/doc-dynamic-page.service';
import {
  DynamicPageParams,
  PageDef,
} from '../pages/project-page/doc-dynamic-page/dynamic-page/models';
import { ProjectPage } from '@shared/models/project-page';
import { LogoService } from '../projects/logo.service';
import { RootEntityService } from '../projects/root-entity.service';
import { map, shareReplay } from 'rxjs/operators';

@Injectable()
export class AppDocDynamicPageService extends DocDynamicPageService {
  constructor(
    private logoService: LogoService,
    private rootEntityService: RootEntityService,
    private injector: Injector,
  ) {
    super();
  }

  async getDocDynamicPage(
    page: ProjectPage,
    _pageDef: PageDef,
  ): Promise<DynamicPageParams> {
    let customDataSource;
    if (page.customDataSource) {
      const { ProjectCustomDataSources } = await import(
        '../projects-custom/project-custom-data-sources'
      );
      const projectCustomDataSources = this.injector.get(
        ProjectCustomDataSources,
      );
      customDataSource = projectCustomDataSources.getCustomDataSource(
        page.customDataSource,
      );
    }

    return {
      logo$: this.logoService.logo$,
      brandColor$:
        this.rootEntityService.currentRootEntityUpdatedRealtimeData$.pipe(
          map((rootEntity) => rootEntity?.brandColor),
          shareReplay(1),
        ),
      ...(customDataSource ? { datasource: customDataSource } : {}),
    };
  }
}
